module.exports = __webpack_public_path__ + "static/clientsPaint-0d5458d60c200224fd1aae69bf8b6f70.png";